import { getUserId } from "../../common/function";
import { authHeader } from "../../common/mainfunction";
import { GET_NOTIFICATION_URL } from "../../common/url";
import API from "../../constants/API";
import { NOTIFY_COUNT } from "./ActionType";
import type { Dispatch } from "redux";

interface NotifyCountAction {
  type: typeof NOTIFY_COUNT;
  payload: number;
}

export function getNotificationDetails() {
  return (dispatch: Dispatch<NotifyCountAction>) => {
    const config = {
      method: "GET",
      url: GET_NOTIFICATION_URL,

      headers: authHeader(),
      params: {
        userId: getUserId(),
      },
    };
    API(config)
      .then((response) => {
        const { status, messageCount, _readedMessages, _unreadedMessages } = response.data;

        if (status === "Success") {
          dispatch({
            type: NOTIFY_COUNT,
            payload: messageCount[0].totalCount,
          });
        }
      })

      .catch((error) => {
        if (error.response) {
          const { _data } = error.response;
        }
      });
  };
}
